// extracted by mini-css-extract-plugin
module.exports = {"carrierWrapper":"ClientInsurance_carrierWrapper__249Ae","title":"ClientInsurance_title__kBjXE","itemText":"ClientInsurance_itemText__3Ov6G"};